<template>
  <v-list dense>
    <v-list-item>
      <v-list-item-icon><v-icon color="success">check_box</v-icon></v-list-item-icon>
      <v-list-item-content>{{ $t('withdraws.withdraw_methods.bank.info.description_1') }}</v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-icon><v-icon color="success">check_box</v-icon></v-list-item-icon>
      <v-list-item-content>{{ $t('withdraws.withdraw_methods.bank.info.description_2') }}</v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-icon><v-icon color="success">check_box</v-icon></v-list-item-icon>
      <v-list-item-content>{{ $t('withdraws.withdraw_methods.bank.info.description_3') }}</v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'BankMethodInfo'
}
</script>
